module.exports = __webpack_public_path__ + "static/media/existing_merchant_served_card_corner.5881e8d5.svg";